<template>
  <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.75 21.9741V36.7202C6.75 39.0143 8.76472 40.874 11.25 40.874H42.75C45.2353 40.874 47.25 39.0143 47.25 36.7202V18.0279C47.25 18.0186 47.25 18.0093 47.2499 18V21.974L31.0501 30.794C28.6501 32.234 25.3501 32.234 22.9501 30.794L6.75 21.9741Z"
      fill="#E9E9E9"
    />
    <path
      d="M47.25 17.1L31.0502 25.92C28.6502 27.36 25.3502 27.36 22.9502 25.92L6.75 17.1C6.75 15.3 9 13.5 11.25 13.5H42.75C45.4327 13.5 47.25 15.3 47.25 17.1Z"
      fill="#E9E9E9"
    />
  </svg>
</template>
